// components/Investments/InvestorBenefitsBanner.jsx
/* eslint-disable @next/next/no-img-element */
import * as React from "react";
import { Box } from "@mui/material";
import Heading from "../heading";

export default function InvestorBenefitsBanner({ data, bgcolor }) {
    if (!data) return null;
    const { sectionId, title, subtitle, image } = data;

    return (
        <Box
            component="section"
            id={sectionId}
            sx={{
                position: "relative",
                width: "100%",
                bgcolor: bgcolor ?? "#ffffff",
                overflow: "hidden",
                scrollMarginTop: { xs: "80px", md: "96px" },
            }}
        >
            <Box
                component="img"
                src={`${process.env.IMAGE_BASE_URL}${image?.src}`}
                alt={image?.alt}
                loading="lazy"
                sx={{ width: "100%", height: "auto", display: "block" }}
            />

            {/* heading sits over the top of the banner */}
            <Box
                sx={{
                    position: "absolute",
                    top: { xs: 8, sm: 16, md: 32, lg: 40 },
                    left: 0,
                    right: 0,
                    px: 2,
                    pointerEvents: "none",
                    // the banner is a fixed 2:1 image, so the heading has to shrink with it
                    "& h2": { fontSize: { xs: 15, sm: 22, md: 32, lg: 42 } },
                    "& p": { fontSize: { xs: 9, sm: 13, md: 16, lg: 20 } },
                    "& img": { // the underline scribble
                        width: { xs: 70, sm: 105, md: 150, lg: 200 },
                        bottom: { xs: -10, sm: -15, md: -22, lg: -30 },
                    },
                }}
            >
                <Heading
                    title={title}
                    subtitle={subtitle}
                    mb={0}
                    titleColor="#ffffff"
                    subtitleColor="rgba(255,255,255,.85)"
                />
            </Box>
        </Box>
    );
}
